import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import type { AuthenticationState } from './authentication.types'
import { moduleName } from './authentication.types'

const initialState: AuthenticationState = {
  isStaffUser: null,
  authInitialized: false,
}

const slice = createSlice({
  name: moduleName,
  initialState,
  reducers: {
    setIsStaffUser: (state: AuthenticationState, action: PayloadAction<boolean>) => {
      state.isStaffUser = action.payload
    },
    setAuthInitialized: (state: AuthenticationState, action: PayloadAction<boolean>) => {
      state.authInitialized = action.payload
    },
  },
})

export default slice
